import { MigrationSpec } from "../migration.models"

const extractContactInfoFlowBlockTemplates: MigrationSpec = {
  type: "SEED_EXTRACT_CONTACT_INFO_FLOW_BLOCK_TEMPLATES",
  collection: "FlowBlockTemplate",
  risk: "SAFE",
  title: {
    en: "FlowBot → Extract data block template",
    tr: "FlowBot → Veri ayıkla blok şablonu"
  },
  description: {
    en:
      "Inserts, when missing and keyed by `type` + `category`, the Extract data block " +
      "(`extract_contact_info`). Written with `$setOnInsert`, so a second run changes nothing " +
      "and an existing (possibly edited) template is never overwritten.",
    tr:
      "Yoksa, `type` + `category` anahtarıyla Veri ayıkla bloğunu " +
      "(`extract_contact_info`) ekler. `$setOnInsert` ile yazılır: ikinci çalıştırma hiçbir şey " +
      "değiştirmez, mevcut (düzenlenmiş olabilecek) şablonun üzerine asla yazılmaz."
  },
  expectedDocuments: {
    filter: {
      $or: [{ type: "extract_contact_info", category: "extract_contact_info" }]
    },
    count: 1
  },
  notes: [
    {
      en: "Until this runs, the node has no block to hold its success/failure branches.",
      tr: "Bu çalışana kadar node'un başarılı/başarısız dallarını taşıyacak bloğu olmaz."
    }
  ]
}

export default extractContactInfoFlowBlockTemplates
